import 'css-chunksrc/client/pages/zonePage/menu/styles.scss';export default {
  "menu": "_menu_lxqep_1",
  "input": "_input_lxqep_10",
  "avatar": "_avatar_lxqep_22",
  "name": "_name_lxqep_29",
  "toggleArrow": "_toggleArrow_lxqep_42",
  "open": "_open_lxqep_50",
  "list": "_list_lxqep_57",
  "item": "_item_lxqep_70",
  "dangerous": "_dangerous_lxqep_77",
  "inactive": "_inactive_lxqep_81",
  "main": "_main_lxqep_85"
};